export const STUDENT_APPLICATION_TYPES = [
  'student_only_guarantor',
  'student_default',
  'student_guarantor_mandatory_generic_link',
];

export const MAX_INCENTIVES_IN_APPLICATION = 2;

export const DUMMY_INCENTIVES = [
  {
    id: 1,
    internal_name: 'mega-promo',
    internal_description: 'super promo',
    externally_visible: true,
    external_name: 'mega-promo',
    external_description: 'Fall Incentive Save $100 on your first three months of rent',
    incentive_type: 'rental_discount',
    target_fee: 'application_fee',
    deferral_until_month: 1,
    approval_type: 'automatic',
    incentive_codes: 'CODE1234',
    internal_code: 'CODE1234',
    schedule_type: 'monthly',
    calculation_type: 'absolute',
    schedule_monthly_amount: 100,
    schedule_monthly_duration_months: 6,
    schedule_monthly_starting_month: 1,
    schedule_custom_events: [],
    status: 'published',
    landlord_id: 1,
  },
];

export const DUMMY_APPLICATION = {
  property: {
    address: {
      unit_number: null,
      street: '150 Roehampton Ave',
      city: 'Toronto',
      province: 'Ontario',
      postal_code: 'M4P0A2',
      country: 'Canada',
    },
    hero_image_url: null,
    services: null,
    utilities: null,
  },
  cotenants: [
    {
      id: 1,
      full_name: 'John Doe',
      applicant_type: 'lead_applicant',
      application_template_id: 1,
      lifecycle: {
        status: 'in_progress',
        substatus: 'in_progress',
        status_label: 'In progress',
        substatus_label: 'In progress',
      },
    },
    {
      id: 2,
      full_name: 'Jane Doe',
      applicant_type: 'lead_applicant',
      application_template_id: 1,
      lifecycle: {
        status: 'in_progress',
        substatus: 'in_progress',
        status_label: 'In progress',
        substatus_label: 'In progress',
      },
    },
  ],
  unit: {
    unit_number: '101',
    unit_type_name: 'Two Bedroom',
    quantity_bedrooms: null,
    quantity_bathrooms: null,
    max_occupancy: null,
    smoking: false,
    pets_allowed: null,
  },

  additional_occupants: [
    {
      id: 1,
      full_name: 'Baby Doe',
    },
  ],
  lease: {
    lease_start_date: '2022-09-25T04:00:00.000Z',
    lease_end_date: '2023-09-25T23:59:59.999Z',
    early_move_in_date: '2022-09-25T04:00:00.000Z',
    lease_term_in_months: 12,
    total_monthly_rent: 1000.0,
    total_deposit: 500.0,
    lease_pricing: {
      rent_amount: 1000.0,
      deposit_amount: 500.0,
      key_deposit_amount: 0,
    },
    lease_charges: [],
    rental_incentives: [],
  },
};

export const DUMMY_COTENANT = {
  id: 1,
  lease_id: 1,
  application_id: 1,
  title: 'Preview mode',
  applicant_type: 'lead_applicant',
  lifecycle: {
    status: 'in_progress',
    substatus: 'in_progress',
    status_label: 'In progress',
    substatus_label: 'In progress',
  },
  lease: {
    id: 1,
    property_name: 'Preview heights',
    unit_number: '101',
    lease_start_date: '2022-09-25T04:00:00.000Z',
    lease_end_date: '2023-09-25T23:59:59.999Z',
    early_move_in_date: '2022-09-25T04:00:00.000Z',
    lease_term_in_months: 12,
    total_monthly_rent: 1000.0,
    total_deposit: 500.0,
    lease_pricing: {
      id: 1,
      rent_amount: 1000.0,
      deposit_amount: 1000.0,
      key_deposit_amount: 25.0,
      total_rent_amount: 1100.0,
      deposit_owing: 450.0,
      total_deposit_amount: 1050.0,
      total_batch_payments_paid: 500.0,
      total_prepayments: 100.0,
      lease_charges: [
        {
          id: 1,
          item_name: 'Parking',
          item_type: 'Parking',
          rent_amount: 100.0,
          deposit_amount: 25.0,
          key_deposit_amount: 0.0,
          ancillary_item: {
            id: 1,
            item_type: 'Parking',
            asset_number: 'p1',
            is_asset: true,
            is_rentable: true,
            market_amount: 100.0,
            market_deposit_amount: 25.0,
            market_key_deposit_amount: 0.0,
          },
        },
      ],
      prepayments: [
        {
          id: 1,
          amount: 100.0,
          start_date: '2022-09-25T04:00:00.000Z',
          incentive: '$100 off',
        },
      ],
      batch_payments: [
        {
          id: 1,
          amount: 500.0,
          created_at: '2022-08-25T04:00:00.000Z',
          cotenant_full_name: 'John Doe',
        },
      ],
      payment_details: {
        required: false,
        split_pay: true,
        hold: true,
        landlord_absorbs_fee: true,
        fee_calculation: {
          percent: 5,
          fixed: 100,
        },
      },
    },
  },
  application: {
    id: 1,
    lease_id: 1,
    lifecycle: {
      status: 'in_progress',
      substatus: 'in_progress',
      status_label: 'In progress',
      substatus_label: 'In progress',
    },
    property: {
      id: 1,
      name: 'Preview heights',
      unique_id: '123456',
    },
    unit: {
      id: 1,
      unit_number: '101',
      unit_type_name: '1 Bedroom',
    },
    cotenants: [
      {
        id: 1,
        full_name: 'Jane Doe',
        applicant_type: 'lead_applicant',
        lifecycle: {
          status: 'in_progress',
          substatus: 'in_progress',
          status_label: 'In progress',
          substatus_label: 'In progress',
        },
      },
      {
        id: 2,
        full_name: 'John Doe',
        applicant_type: 'coapplicant',
        lifecycle: {
          status: 'in_progress',
          substatus: 'in_progress',
          status_label: 'In progress',
          substatus_label: 'In progress',
        },
      },
    ],
    additional_occupants: [
      {
        id: 1,
        full_name: 'Jimmy Doe',
      },
    ],
  },
};

export const DATE_FIELDS = {
  birthday: true,
};
